import { Button } from "@material-ui/core"
import { useRouter } from "next/router"
import styled from "styled-components"
import colors from "theme/colors"
import { TypographyRtl } from "theme/shared"
import BackIcon from "./icons/BackIcon"

const StyledButton = styled(Button)`
  color: ${(p) => p.theme.colors.onyx};
  border-bottom: none;
  margin: 0px;
  &:hover {
    border-bottom: none;
    margin: 0px;
    color: ${(p) => p.theme.colors.onyx};
  }
`

const BackButton = () => {
  const { back } = useRouter()

  const handleBack = () => {
    back()
  }

  return (
    <>
      <BackIcon width="14px" height="14px" color={colors.onyx} />
      <TypographyRtl
        $fontSize="16px"
        $fontWeight="300"
        $color="rgb(86, 96, 102)"
        onClick={handleBack}
      >
        חזרה
      </TypographyRtl>
    </>
  )
}

export default BackButton
